<template>
    <div>
        <div class="row">
            <div class="col">
                <files-tank-card-usages-upload
                />
                <br>
                <files-tank-card-usages-table
                    :files-under-processing="filesUnderProcessing"
                    :files-processed="filesProcessed"
                />

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            filesUnderProcessing: Array,
            filesProcessed: Array,
        },
        data() {
            return {};
        },
        methods: {}

    }
</script>
